package tta.destinigo.talktoastro.feature_authentication.persentation.otp_validation_page

sealed class OtpValidationEvent {
    data object OnLoginRegister : OtpValidationEvent()
    data class OnValidateOTP(val otpFields: List<String>) : OtpValidationEvent()
    data object OnResendOTP : OtpValidationEvent()
}
